import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Hospital Owner",
    role: "Leading Hospital, Patna",
    text: "Excellent AI Audit which exactly identified the problem areas followed by some great solution advices to be deployed in near future. Their team understood our hospital operations deeply and delivered actionable insights within weeks.",
    stars: 5,
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="py-24 md:py-32 relative warm-section-alt">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-12">
          <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
            className="text-xs font-bold uppercase tracking-[0.2em] text-[#2a9d8f] mb-4">What Our Clients Say</motion.p>
          <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#2d2926]" style={{ fontFamily: 'Fraunces, serif' }}>
            Client <span className="gradient-text">Testimonials</span>
          </motion.h2>
        </div>
        <div className="grid grid-cols-1 max-w-2xl gap-6">
          {testimonials.map((t, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} data-testid={`testimonial-card-${i}`}>
              <div className="warm-card p-8">
                <Quote className="text-[#2a9d8f]/20 w-7 h-7 mb-4" />
                <p className="text-base text-[#3d3832] leading-relaxed mb-6">{t.text}</p>
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: t.stars }).map((_, j) => <Star key={j} className="w-4 h-4 text-[#d4a853] fill-[#d4a853]" />)}
                </div>
                <p className="text-sm font-semibold text-[#2d2926]">{t.name}</p>
                <p className="text-xs text-[#8a8078]">{t.role}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
